import React, { Component } from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { Button, DialogContainer, TextField } from "react-md";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import ApiRequestService from "../component/ApiRequestService";
import restoreQuestionBankHandler from "../component/ArchiveRestoreAPI";
import LoadingSpinner from "../component/LoadingSpinner";
import TableRow from "../component/TableRow";
import "../css/mediaCss.css";
import questionListStyles from "../css/questionListStyles.css .js";
import styles from "../css/styles.css.js";
import UserAccessDetails from "../lib/UserAccessDetails";
import CreateExplanation from "./CreateExplanation";
import { AppSetting, AppProperties } from '../common/function';
import "./explanation.css";
import ExplanationPreview from "./ExplanationPreview.js";


let explanation = {
  explanation_name: "",
  explanation_id: "",
  explanation_text: "",
  subject_id: 0,
  topic_id: 0,
  category_id: 0,
  subcategory_id: 0
};
export default class ExplanationsList extends Component {
  userAccessDetails = new UserAccessDetails();
  appProperties = AppProperties();
  AppSetting = AppSetting()

  constructor(props) {
    super(props);
    this.state = {
      pageLoading: true,
      explanations: [],
      saveOrderShow: false,
      visibleAddExplanation: false,
      temp_explanation: explanation,
      temp_id: "",
      addMode: true,
      categoryDiv: true,
      questionsDiv: false,
      // explanationDiv: false

      visible: false,

      explanationName: "",
      explanationText: "",
      selectedSubjectId: 0,
      selectedTopicId: 0,
      selectedCategoryId: 0,
      selectedSubCategoryId: 0,
      selectedExplanationId: 0,
      selectedExplanationName: "",
      selectedExplanationText: "",
      selectedAltExplanationText: "",
      responseExplanations: [],
      selectedIndex: 0,
      loading: true,
      copyMode: 0,
      errorMessage: "",
      errorType: "",
      selectedRowIndex: -1,
      previewExplanation: false,
      showPreview: false,
      showLivePreview: false,
      
      instructor_name:  window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole: parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects: [],
      currSubject: false,
      explanation: null
    };
    this.changeExplanationName = this.changeExplanationName.bind(this);
    this.addExplanation = this.addExplanation.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);
    this.updateExplanation = this.updateExplanation.bind(this);
    this.hideSubCategoryExplanation = this.hideSubCategoryExplanation.bind(this);
  }

  componentWillMount() {
    //console.debug("et ",this.state.explanations,"readonly ",this.props.readOnly," ",this.props.archive_mode)
    if (this.state.explanations.length === 0) {
      var sub_id = parseInt(this.props.subject_id, 10);
      var top_id = parseInt(this.props.topic_id, 10);
      var catg_id = parseInt(this.props.category_id, 10);
      var subcatg_id = parseInt(this.props.subcategory_id, 10);
      // var sub_id =6;
      // var top_id = 1;
      // var catg_id = 1;
      // var subcatg_id = 0;
      let payload = {
        // subject_id: this.state.subject_id
        explanation: {
          subject_id: sub_id,
          topic_id: top_id,
          category_id: catg_id,
          subcategory_id: subcatg_id
        },
        is_topic_exp_needed: 0,
        is_cat_exp_needed: 0
      };

      if (this.props.archive_mode === "true") {
        payload["archive_id"] = this.props.archive_id;
        payload["archive_mode"] = true;
      }

      ApiRequestService({
        method: "post",
        url: "/getAllExplanations",
        data: payload
      }).then(res => {
        if (res.data.data != null) {
          console.debug(res.data.data.subcat_explanations);
          if (res.data.data.subcat_explanations != null) {
            let explanationsList = res.data.data.subcat_explanations;
            let instSubjectPromise = this.userAccessDetails.getSubjectsByInstructor();
            instSubjectPromise
              .then(subjectsByIns => {
                let currSubject = false;
                if (subjectsByIns !== null) {
                  if (subjectsByIns[sub_id] === true) {
                    currSubject = true;
                  }
                }
                if (this.props.updateTotalCount) {
                  this.props.updateTotalCount(explanationsList ? explanationsList.length : 0);
                }
                this.setState({
                  explanations: explanationsList,
                  pageLoading: false,
                  instSubjects: subjectsByIns,
                  currSubject: currSubject
                });
              })
              .catch(err => {
                this.setState({ pageLoading: false });
                this.hide();
                NotificationManager.error(err, "ERROR", 3000);
              });
          }
        }
        console.debug("explantion =", this.state.explanations);
      });
    }
  }

  show = (id, isCopyMode, isMoveMode) => {
    console.debug("Show Called", isCopyMode);
    console.debug("this.state.explanation[id]", this.state.explanations);

    console.log(this.state + " - ID " + id);

    var tempSelectedSubjectId = parseInt(
      this.state.explanations[id].subject_id,
      10
    );
    var tempSelectedTopicId = parseInt(
      this.state.explanations[id].topic_id,
      10
    );
    var tempSelectedCategoryId = parseInt(
      this.state.explanations[id].category_id,
      10
    );
    var tempSelectedSubCategoryId = parseInt(
      this.state.explanations[id].subcategory_id,
      10
    );
    var tempSelectedExplanationId = parseInt(
      this.state.explanations[id].explanation_id,
      10
    );
    var tempSelectedExplanationText = this.state.explanations[id].text;
    var tempSelectedAltExplanationText = this.state.explanations[id]
      .alt_explanation_text;
    var tempSelectedExplanationName = this.state.explanations[id]
      .explanation_name;

    console.debug(
      "edit  explanation i" +
        id +
        " text: " +
        this.state.explanations[id].explanation_text
    );
    console.debug(
      "edit  explanation i:" +
        id +
        " id: " +
        this.state.explanations[id].explanation_id
    );
    console.debug("edit  subject_id i:" + id + " id: " + tempSelectedSubjectId);
    console.debug("edit  topic_id i:" + id + " id: " + tempSelectedTopicId);
    console.debug("edit  cat i:" + id + " id: " + tempSelectedCategoryId);
    console.debug(
      "edit  subcategory_id i:" + id + " id: " + tempSelectedSubCategoryId
    );

    this.setState({
      selectedSubjectId: tempSelectedSubjectId,
      selectedTopicId: tempSelectedTopicId,
      selectedCategoryId: tempSelectedCategoryId,
      selectedSubCategoryId: tempSelectedSubCategoryId,
      selectedExplanationId: tempSelectedExplanationId,
      selectedExplanationText: tempSelectedExplanationText,
      selectedAltExplanationText: tempSelectedAltExplanationText,
      selectedExplanationName: tempSelectedExplanationName,
      visible: true,
      selectedRowIndex: -1,
      showPreview: false,
      selectedIndex: id,
      copyMode: isCopyMode,
      moveMode: isMoveMode
    });
    console.debug(
      "edit  explanation i" +
        id +
        " text: " +
        this.state.explanations[id].explanation_text
    );
    console.debug(
      "edit  explanation i:" +
        id +
        " id: " +
        this.state.explanations[id].explanation_id
    );
    //this.setState({ visible: true });
  };

  hideSubCategoryExplanation(payload){
    if (this.state.copyMode === 1 && this.redirectURL !== undefined) {
      NotificationManager.info(
        "Duplication Successful!",
        "You will be redirected to the new Destination",
        3000
      );
      window.location = this.redirectURL;
    }
    for (let explanation of this.state.explanations) {
      if (explanation.subcategory_id === payload.subcategory_id && explanation.explanation_id === payload.explanation_id) {
        explanation.explanation_name = payload.explanation_name;
        break;
      }
    }
    this.setState({
      visible: false,
      renderNode: null,
      explanations: this.state.explanations,
    });
  }

  hide = (res, index) => {
    console.debug("response question close= ", res);
    if (this.state.copyMode === 1 && this.redirectURL !== undefined) {
      NotificationManager.info(
        "Duplication Successful!",
        "You will be redirected to the new Destination",
        3000
      );
      window.location = this.redirectURL;
    }
    var tempExplanationArrList = this.state.explanations;
    if (res !== undefined && res.data !== undefined) {
      if (res.data.data.explanation_name !== undefined) {
        console.debug("response explanation close= ", index);
        console.debug("explanation array = ", this.state.explanations);
        // var tempQuestionArrList = this.state.questions;

        if (
          tempExplanationArrList[index].explanation_name !==
          res.data.data.explanatino_name
        ) {
          tempExplanationArrList[index].explanation_name =
            res.data.data.explanation_name;
        }
      }
    }

    this.setState({
      visible: false,
      renderNode: null,
      explanations: tempExplanationArrList
    });
  };

  changeExplanationName(e) {
    var tempExplanationName = e;
    this.setState({
      explanationName: tempExplanationName
    });
    console.debug("explanationName = ", this.state.explanationName);
  }

  addExplanation() {
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    console.debug("this is in addExplanation " + this.state.explanationName);
    if (
      this.state.explanationName === null ||
      this.state.explanationName.trim() === ""
    ) {
      alert('Please enter a valid "Explanation Name"');
      return;
    }
    this.setState({ loading: true });
    console.debug("Add Explanation ");
    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var cat_id = parseInt(this.props.category_id, 10);
    var subcat_id = parseInt(this.props.subcategory_id, 10);

    var explanationName = this.state.explanationName.trim();
    // if(questionName != null && questionName != ""){
    //    alert("Please enter question name.");
    //     return
    // }

    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      explanation_name: explanationName
    };
    ApiRequestService({
      method: "post",
      url: "/addExplanation",
      data: payload
    }).then(res => {
      console.debug(
        "Add explanation response",
        res,
        this.state.explanations,
        this.state.explanations.slice()
      );

      var tempExplanations = this.state.explanations.slice();

      if (res.data.message !== null && res.data.message !== "") {
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.addExplanationHide();
        NotificationManager.error(res.data.message, "ERROR", 3000);
        return;
      }

      if (res.data.data != null) {
        if (res.data.data.explanation_name != null) {
          tempExplanations.push({
            explanation_name: res.data.data.explanation_name,
            explanation_id: res.data.data.explanation_id,
            subject_id: res.data.data.subject_id,
            topic_id: res.data.data.topic_id,
            category_id: res.data.data.category_id,
            subcategory_id: res.data.data.subcategory_id
          });

          this.setState(
            {
              explanations: tempExplanations,
              loading: false
            },
            () => {
              this.show(this.state.explanations.length - 1, false, false);
            }
          );
          if (this.props.updateTotalCount) {
            this.props.updateTotalCount(tempExplanations ? tempExplanations.length : 0);
          }
        }
      }
      console.debug("this.state.explanations", this.state.explanations);
      this.setState({
        loading: false
      });
    });

    this.addExplanationHide();
  }

  addExplanationShow = () => {
    //this.errorMessageHide();
    this.setState({ visibleAddExplanation: true });
  };
  addExplanationHide = () => {
    this.setState({
      visibleAddExplanation: false,
      addMode: true
    });
  };
  //bug-tracker#69
  setRedirectURL(url) {
    this.redirectURL = url;
  }
  delete = id => {
    //bug id 167 fixes
    confirmAlert({
      title: "Do you really want to delete this explanation?",
      message: "Press Confirm to submit",

      cancelLabel: "Confirm",
      confirmLabel: "Cancel",
      onCancel: () => this.deleteExplanation(id)
    });
  };

  deleteExplanation(id) {
    this.setState({ loading: true });
    console.debug(
      "Deleting Explanation i:" +
        id +
        " id: " +
        this.state.explanations[id].explanation_id
    );
    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var cat_id = parseInt(this.props.category_id, 10);
    var subcat_id = parseInt(this.props.subcategory_id, 10);
    var explanationId = parseInt(
      this.state.explanations[id].explanation_id,
      10
    );
    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      explanation_id: explanationId,
      archive_mode: this.props.archive_mode
    };
    ApiRequestService({
      method: "post",
      url: "/deleteExplanation",
      data: payload
    })
      .then(res => {
        console.debug("delete explanation response", res);
        this.state.explanations.splice(id, 1);
        this.setState({
          explanations: this.state.explanations,
          loading: false
        });
        if (this.props.updateTotalCount) {
          this.props.updateTotalCount(this.state.explanations ? this.state.explanations.length : 0);
        }
        console.debug("Spliced Array", this.state.explanations);
      })
      .catch(error => {
        //bug-tracker#162

        console.error("Error When Deleting ", error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            "Unauthorized",
            "You are not authorized to delete explanation",
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }

  updateExplanation(id, text, alt_explanation_text) {
    var exps = this.state.explanations;
    exps[id].text = text;
    exps[id].alt_explanation_text = alt_explanation_text;
    this.setState({
      explanations: exps
    });
  }

  isEnterPressed(event) {
    var code = event.keyCode || event.which;
    if (code === 13) {
      //13 is the enter keycode
      this.addExplanation();
    }
  }

  onPreviewExplanation(id){
    if(id === this.state.selectedRowIndex){
      this.setState({previewExplanation: false , selectedRowIndex: -1})
    }else{
      let explanation = this.state.explanations[id];

      this.setState({
        selectedSubjectId: explanation.subject_id,
        selectedTopicId: explanation.topic_id,
        selectedCategoryId: explanation.category_id,
        selectedSubCategoryId: explanation.subcategory_id,
        selectedExplanationId: explanation.explanation_id,
        selectedExplanationName: explanation.explanation_name,
        selectedExplanationText: explanation.text,
        selectedAltExplanationText: explanation.alt_explanation_text,
        selectedRowIndex: id,
        selectedIndex: id,
        showLivePreview: true,
        explanation: explanation,
      })
     /*  var tempSelectedSubjectId = parseInt( questions[id].subject_id,10 );
      var tempSelectedTopicId = parseInt( questions[id].topic_id, 10);
      var tempSelectedCategoryId = parseInt( questions[id].category_id,10 );
      var tempSelectedSubCategoryId = parseInt( questions[id].subcategory_id,10 );
      var tempSelectedQuestionId = parseInt( questions[id].question_id,10 );
  
      this.setState({
        selectedSubjectId: tempSelectedSubjectId,
        selectedTopicId: tempSelectedTopicId,
        selectedCategoryId: tempSelectedCategoryId,
        selectedSubCategoryId: tempSelectedSubCategoryId,
        selectedQuestionId: tempSelectedQuestionId,
        previewExplanation: true,
        selectedRowIndex: id
      }); */
    }
  }

  render() {
    if (this.state.pageLoading) {
      return <LoadingSpinner />;
    }

    const { visible } = this.state;
    let button = null;
    if (this.state.addMode) {
      button = (
        <button style={styles.addButton} onClick={this.addExplanation}>
          Add Explanation
        </button>
      );
    } else {
      button = <button style={styles.addButton}>Update Explanation</button>;
    }
    var cancelButton = (
      <button style={styles.cancelButton} onClick={this.addExplanationHide}>
        Cancel
      </button>
    );
    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var tbody = null;
    if (this.state.explanations != null) {
      tbody = (
        <tbody>
          {this.state.explanations.map((explanation, i) => (
            <TableRow
              key={i}
              explanationIndex={i}
              data={explanation}
              pushId={"explanations"}
              name={explanation.explanation_name}
              id={explanation.explanation_id}
              text={explanation.text}
              onEditClick={() => this.show(i, 0)}
              onDeleteClick={() => this.delete(i)}
              show_archive_actions={this.props.archive_mode}
              instructorSubject={
                this.state.instSubjects &&
                this.state.instSubjects[explanation.subject_id] === true
              }
              onViewClick={() => this.onPreviewExplanation(i)}
              onArchiveRestoreClick={() =>
                this.onArchiveRestoreClick(explanation)
              }
              selectedRowIndex={this.state.selectedRowIndex}
            />
          ))}
        </tbody>
      );
    }

    return (
      <div>
        {this.state.showLivePreview ? 
          <ExplanationPreview 
            visible={this.state.showLivePreview}
            explanations={this.state.explanations}
            selectedRowIndex={this.state.selectedRowIndex}
            closeLivePreview={() => {
              this.setState({
                selectedRowIndex: null,
                showLivePreview: false
              })
            }}
          />
      : null}


        <div>{this.state.subject_name}</div>

        <table style={{
          ...styles.subCatTable,
          width: this.state.showPreview ? '75%' :'100%',
        }} className="categoryExplanationTable">
          <thead>
            <tr>
              <th colSpan="4" className="AddButtonStyleCategory">
                {this.props.readOnly || this.appProperties.enableLTI ? null : (
                  <div
                    style={
                      this.state.currSubject
                        ? styles.floatRight
                        : { display: "none" }
                    }
                  >
                    <Button className="archive-button" primary raised
                      style={{ float: "right" }}
                      onClick={this.addExplanationShow}
                    >
                      Add a New Explanation
                    </Button>
                  </div>
                )}
              </th>
            </tr>
            <tr style={{...styles.thead, fontWeight:'bold'}}>
              <td>ID</td>
              <td>Name</td>
              {
                   !this.appProperties.enableLTI ? 
                   <td>Actions</td> : ''
                }
            </tr>
          </thead>
          {tbody}
        </table>
        <div>
          <DialogContainer
            id="simple-action-dialog"
            visible={this.state.visibleAddExplanation}
            onHide={this.hide}
            actions={actions}
            //title="New Explanation Name"
            width="500px"
          >
            <p style={{ fontSize: "medium" }}>
              <b>
                <label for="expId">New Explanation</label>
              </b>
            </p>
            <TextField
              id="expId"
              name="explanation_name"
              defaultValue=""
              className="explanationInputText"
              onChange={this.changeExplanationName}
              style={questionListStyles.dialogText}
              onKeyPress={this.isEnterPressed.bind(this)}
            />
          </DialogContainer>
        </div>
        <DialogContainer
          id="navigation-drawer-demo"
          aria-label="Navigation Drawer Demo"
          visible={visible}
          fullPage
          focusOnMount={false}
          onShow={this.handleShow}
          onHide={this.hide}
        >
          <div>
            {" "}
            <Button icon onClick={this.hide}>
              close
            </Button>
          </div>
          <div style={{ overflow: "hidden" }}>
            <CreateExplanation
              selectedSubjectId={this.state.selectedSubjectId}
              selectedTopicId={this.state.selectedTopicId}
              selectedCategoryId={this.state.selectedCategoryId}
              selectedSubCategoryId={this.state.selectedSubCategoryId}
              selectedExplanationId={this.state.selectedExplanationId}
              selectedExplanationName={this.state.selectedExplanationName}
              selectedExplanationText={this.state.selectedExplanationText}
              selectedAltExplanationText={this.state.selectedAltExplanationText}
              explanation={this.state.explanations[this.state.selectedIndex]}
              hidemodule={this.hide}
              selectedIndex={this.state.selectedIndex}
              copyMode={this.state.copyMode}
              moveMode={this.state.moveMode} //Adding Move Option
              setRedirectURL={this.setRedirectURL.bind(this)}
              close={this.hideSubCategoryExplanation}
              onUpdate={this.updateExplanation}
              archive_id={this.props.archive_id}
              archive_mode={this.props.archive_mode}
              readOnly={this.props.readOnly}
              currSubject={this.state.currSubject}
              showPreview={false}
            />
          </div>
          <br />

          <div />
        </DialogContainer>
        <br />
        <br />
        <center>
          { !this.appProperties.enableLTI  ? 
          
          <div
            style={
              this.state.currSubject ? { display: "none" } : { width: "35%" }
            }
            className="image-resize-warning"
          >
            <p>
              <b>Note :</b> Contact Administrator to gain access to edit this
              page.
            </p>
          </div> : ""
        
        }
          {
            this.appProperties.enableLTI  ? 
            <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
            <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
            </div> : " "
          }
        </center>
      </div>
    );
  }

  //Archive Restore
  onArchiveRestoreClick = object => {
    let payload = {
      subject_id: object.subject_id,
      topic_id: object.topic_id,
      category_id: object.category_id ? object.category_id : 0,
      subcategory_id: object.subcategory_id ? object.subcategory_id : 0,
      explanation_id: object.explanation_id
    };
    restoreQuestionBankHandler(payload);
  };
}
